import React from "react";
import BookingDetails from "./BookingDetails/BookingDetails";

export const HullOnLandProrata = () => {
  return (
    <>
      <BookingDetails premiumType="HULL_ON_LAND_PRORATA" />
    </>
  );
};
